/**
 * One React key for both ordered surfaces, so a reorder reconciles a product to
 * its own node. `entryUID` first because `uid` is `@deprecated`, matching
 * `ProductGridCard`'s `helpers.ts`.
 */
export const productSortKey = (
  product: { uid?: string; entryUID?: string } | null | undefined,
): string | undefined => product?.entryUID ?? product?.uid;
